import { useState, useEffect } from "react";

import { getKvkkContent } from "@/src/services/contracts";

import LoaderContractModalWrapper from "components/loader-contract-modal-wrapper";
import Loader from "components/loader";

const KvkkContent = () => {
  const [content, setContent] = useState();

  useEffect(() => {
    getKvkkContent().then((data) => {
      const template = data.data.template;
      setContent(template);
    });
  }, []);

  return (
    <>
      {content ? (
        <div dangerouslySetInnerHTML={{ __html: content }} />
      ) : (
        <LoaderContractModalWrapper>
          <Loader />
        </LoaderContractModalWrapper>
      )}
    </>
  );
};

export default KvkkContent;
